import React, { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { getSessionCustomers } from "../../services/adminTimeTableServices";

const SessionCustomersPage = () => {

  const { sessionId } = useParams();
  const navigate = useNavigate();

  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    loadCustomers();
  }, []);

  const loadCustomers = async () => {

    try {
      setLoading(true);
      const res = await getSessionCustomers(sessionId);

      setData(res.data);
    } catch (err) {
      alert("Failed to load session customers");
    } finally {
      setLoading(false);
    }
  };

  const downloadCSV = () => {
  if (!data?.customers?.length) {
    alert("No customers to download");
    return;
  }

  const headers = ["Name", "Email", "Status", "Booked At"];

  const rows = data.customers.map((c) => [
    c.name || "Unknown",
    c.email || "N/A",
    c.status,
    new Date(c.bookedAt).toLocaleString(),
  ]);

  const csvContent =
    [headers, ...rows]
      .map((row) =>
        row
          .map((value) =>
            `"${String(value).replace(/"/g, '""')}"`
          )
          .join(",")
      )
      .join("\n");

  const blob = new Blob([csvContent], {
    type: "text/csv;charset=utf-8;",
  });

  const url = URL.createObjectURL(blob);

  const link = document.createElement("a");
  link.href = url;
  link.download = `session_${sessionId}_customers.csv`;
  document.body.appendChild(link);
  link.click();

  document.body.removeChild(link);
  URL.revokeObjectURL(url);
};


  if (loading) {
    return <p>Loading customers...</p>;
  }

  if (!data) {
    return <p>No data found.</p>;
  }

  if (!Array.isArray(data.customers)) {
    return <p>Invalid customer data</p>;
  }


  return (
    <div className="admin-page">
      <button onClick={() => navigate(-1)}>⬅ Back</button>

      <button
       onClick={downloadCSV}
        style={{
        marginLeft: "10px",
        padding: "6px 12px",
        backgroundColor: "#4CAF50",
        color: "#fff",
        border: "none",
        borderRadius: "4px",
        cursor: "pointer",
        }}
    >
    ⬇ Download CSV
    </button>

      <h2>👥 Session Customers</h2>

      {/* Summary */}
      <div style={{ display: "flex", gap: "20px", marginBottom: "20px" }}>
        <div style={summaryCard}>
          <h4>Booked</h4>
          <p>{data.totalBooked}</p>
        </div>
        <div style={summaryCard}>
          <h4>Cancelled</h4>
          <p>{data.totalCancelled}</p>
        </div>
      </div>

      {/* Table */}
      <table style={{ width: "100%", borderCollapse: "collapse" }}>
        <thead>
          <tr style={{ backgroundColor: "#f0f0f0" }}>
            <th>Name</th>
            <th>Email</th>
            <th>Status</th>
            <th>Booked At</th>
          </tr>
        </thead>
        <tbody>
          {data.customers.map((c, index) => {

            return (
              <tr key={c.userId ?? index}>
                <td>{c.name || "Unknown"}</td>
                <td>{c.email || "N/A"}</td>
                <td>
                  <span
                    style={
                      c.status === "BOOKED"
                        ? badgeBooked
                        : badgeCancelled
                    }
                  >
                    {c.status}
                  </span>
                </td>
                <td>
                  {c.bookedAt
                    ? new Date(c.bookedAt).toLocaleString()
                    : "N/A"}
                </td>
              </tr>
            );
          })}
        </tbody>
      </table>
    </div>
  );
};

/* ================= Styles ================= */

const summaryCard = {
  padding: "15px",
  borderRadius: "8px",
  backgroundColor: "#f9f9f9",
  minWidth: "150px",
  textAlign: "center",
};

const badgeBooked = {
  padding: "4px 8px",
  backgroundColor: "#4CAF50",
  color: "#fff",
  borderRadius: "4px",
};

const badgeCancelled = {
  padding: "4px 8px",
  backgroundColor: "#F44336",
  color: "#fff",
  borderRadius: "4px",
};

export default SessionCustomersPage;
